import React from "react";
import { WithAPICall } from "../utils/apiUtil";
import _ from "lodash";
import Markdowner from "./Markdowner";
import { Card, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import SummaryMessageAudio from "./SummaryMessageAudio";

class CaseAtMessage extends React.Component {
  state = {
    toDoList: [],
    ENCOUNTER_COMPLAINTS: "",
    ENCOUNTER_DIAGNOSIS: "",
    ENCOUNTER_MEDICINES: "",
    ENCOUNTER_OBSERVATIONS: "",
    ENCOUNTER_SX: "",
    ENCOUNTER_SUMMARY: "",
    ENCOUNTER_INCONSISTENCIES: "",
    ENCOUNTER_SUMMARY_PATIENT_LANGUAGE: "",
  };
  TO_DO = [
    { type: "ENCOUNTER_SUMMARY", audio: false, nice: "Summary" },
    {
      type: "ENCOUNTER_INCONSISTENCIES",
      audio: false,
      nice: "Inconsistencies",
    },
    {
      type: "ENCOUNTER_SUMMARY_PATIENT_LANGUAGE",
      audio: true,
      nice: "Summary for Patient",
    },
    {
      type: "ENCOUNTER_COMPLAINTS",
      audio: false,
      nice: "Complaints",
    },
    {
      type: "ENCOUNTER_DIAGNOSIS",
      audio: false,
      nice: "Diagnosis",
    },
    {
      type: "ENCOUNTER_MEDICINES",
      audio: false,
      nice: "Medicines",
    },
    {
      type: "ENCOUNTER_OBSERVATIONS",
      audio: false,
      nice: "Observations",
    },
    { type: "ENCOUNTER_SX", audio: false, nice: "Surgeries Advised" },
  ];
  componentDidMount() {
    let keys = this.TO_DO.map((each) => each.type);
    let data = this.props.data;
    let toDoList = [];
    for (var i = 0; i < keys.length; i++) {
      if (!data[keys[i]]) {
        let objIdx = _.findIndex(this.TO_DO, (x) => x.type === keys[i]);
        toDoList.push(this.TO_DO[objIdx]);
      }
    }
    this.setState(
      {
        ...data,
        toDoList: toDoList,
      },
      () => {
        this.generateAllResults();
      }
    );
  }
  generateAllResults = () => {
    let toDoList = this.state.toDoList;
    for (var i = 0; i < toDoList.length; i++) {
      this.generateResults(toDoList[i].type, toDoList[i].audio);
    }
  };
  generateResults = async (tag, audio) => {
    try {
      await this.props.apiCallPostStreamingForAI(
        "/harley/addOutputToCaseMessage",
        {
          caseId: this.props.caseId,
          messageNanoId: this.props.data.nanoid,
          taskTag: tag,
          needsAudioOuput: audio,
        },
        (data) => {
          this.setState({
            [tag]: this.state[tag] + data,
          });
        },
        () => {}
      );
    } catch (err) {
      console.error(err);
    }
  };
  renderEachSegment = () => {
    let keys = this.TO_DO.map((each) => each.type);
    let data = this.state;

    return keys.map((key) => {
      let dd = data[key];
      if (!dd) {
        return null;
      } else {
        let idx = _.findIndex(this.TO_DO, (x) => x.type === key);
        let nice = this.TO_DO[idx].nice;
        if (this.TO_DO[idx].audio) {
          let audioURLKey = "Audio_" + key;
          let audioURL = "";
          if (data[audioURLKey]) {
            audioURL = data[audioURLKey];
          }
          return (
            <SummaryMessageAudio
              caseId={this.props.caseId}
              messageNanoId={this.props.data.nanoid}
              message={dd || ""}
              taskTag={key}
              genAudioUrl={audioURL}
            />
          );
        }
        return (
          <Card
            sx={{
              p: 2,
              m: 2,
              boxShadow: 3,
            }}
          >
            <Stack spacing={1}>
              <Typography variant="overline">{nice}</Typography>
              <Markdowner text={dd} />
            </Stack>
          </Card>
        );
      }
    });
  };
  render() {
    return <Stack spacing={1}>{this.renderEachSegment()}</Stack>;
  }
}

export default WithAPICall(CaseAtMessage);
